import React, { useEffect } from 'react';
import { FaTimes, FaDownload, FaFilePdf } from 'react-icons/fa';
import './PdfViewer.css';

const PdfViewer = ({ pdfPath, deviceName, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target.className === 'pdf-viewer-backdrop') {
      onClose();
    }
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfPath;
    link.download = `Manual_${deviceName}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="pdf-viewer-backdrop" onClick={handleBackdropClick}>
      <div className="pdf-viewer-container">
        <div className="pdf-viewer-header">
          <div className="pdf-viewer-title">
            <FaFilePdf className="pdf-icon" />
            <div>
              <h3>Manual de Instruções - {deviceName}</h3>
              <p>Comandos e configurações completas</p>
            </div>
          </div>
          <div className="pdf-viewer-actions">
            <button className="pdf-download-btn" onClick={handleDownload} title="Baixar PDF">
              <FaDownload /> Baixar
            </button>
            <button className="pdf-close-btn" onClick={onClose} title="Fechar">
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="pdf-viewer-content">
          <iframe
            src={pdfPath}
            title={`Manual ${deviceName}`}
            className="pdf-iframe"
          />
        </div>
      </div>
    </div>
  );
};

export default PdfViewer;

